import { Component } from '@angular/core';
import { BeesFooterComponent } from '../bees-footer/bees-footer.component';
import { BeesHeaderComponent } from '../bees-header/bees-header.component';

@Component({
  selector: 'app-marine-works',
  standalone: true,
  imports: [BeesFooterComponent, BeesHeaderComponent],
  templateUrl: './marine-works.component.html',
  styleUrl: './marine-works.component.scss'
})
export class MarineWorksComponent {

}
